import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const { any, string } = PropTypes;

const propTypes = {
  left: any,
  right: any,
  className: string,
  padding: any,
  center: any,
  backgroundColor: any,
};

const defaultProps = {
  padding: "8px",
};

const groupStyles = {
  display: "flex",
  alignItems: "center",
  flexGrow: 0,
  justifyContent: "space-between",
  flexWrap: "wrap",
};

const spacerStyles = { flexGrow: 1, alignSelf: "center" };

const centerStyles = { flexGrow: 0 };

const Bar = ({ left, right, center, padding, backgroundColor, className }) => (
  <div
    className={classNames("et--bar", className)}
    style={{
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
      justifyContent: center ? "center" : "space-between",
      padding,
      backgroundColor,
    }}
  >
    {center ? (
      <div classname="et--bar--center" style={{ flexGrow: 0 }}>
        {center}
      </div>
    ) : (
      <Fragment>
        {left && (
          <div className="et--bar--left" style={groupStyles}>
            {left}
          </div>
        )}
        <div className="et--bar--center" style={spacerStyles} />
        {right && (
          <div className="et--bar--right" style={groupStyles}>
            {right}
          </div>
        )}
      </Fragment>
    )}
  </div>
);

Bar.displayName = "Bar";

Bar.propTypes = propTypes;

Bar.defaultProps = defaultProps;

const Spacer = ({ width }) => (
  <span className="et--bar--spacer" style={{ width }}>
    {" "}
  </span>
);

Spacer.displayName = "Bar.Spacer";

Spacer.defaultProps = { width: "8px" };

Spacer.propTypes = { width: any };

Bar.Spacer = Spacer;

export { Spacer };

export default Bar;
